import {DataLoader, DataLoaderOptions} from "./dataloader.mjs";
import {DataParser, DataParserOptions} from "./dataparser.mjs";
import {DataDeserializer, DataDeserializerOptions} from "./datadeserializer.mjs";
import { DataTransformerOptions } from "./datatransformer.mjs";
import {Pipeline} from "./pipeline.mjs"
import { DataTransformer } from "./datatransformer.mjs";

export class DataSource{
    constructor(dataSourceOptions){
        var _pipeline = new Pipeline();

        /*
        Object.defineProperty(this,'add',{
            value : _pipeline.add
        });

        Object.defineProperty(this,'run',{
            value : _pipeline.run
        });
        */

        Object.defineProperty(this,'pipeline',{
            get : function(){ return _pipeline }
        })

        this.initDataSource(dataSourceOptions)
    
    }

    // ==========
    // private 
    // ----------
    getPipeline(){ return this.pipeline }

    setName(n){ this.name = n }
    getName(){ return this.name }

    setLoader(d){ this.loader = d;  }
    getLoader(){ return this.loader }

    setParser(p){ this.parser = p }
    getParser(){ return this.parser }

    setDeserializer(d){ this.deserializer =d }
    getDeserializer(){ return this.deserializer }

    setTransformer(d){ this.transformer = d }
    getTransformer(){ return this.transformer }
    
    initName(name){
        this.setName(name);
    }

    initDataLoader(dataLoaderOptions){
        this.setLoader(new DataLoader(dataLoaderOptions)); 
    }

    initDataParser(dataParserOptions){
        if (dataParserOptions) this.setParser(new DataParser(dataParserOptions));
        else console.log('No dataParserOptions');
    }

    initDataDeserializer(dataDeserializerOptions){
        if (dataDeserializerOptions) this.setDeserializer(new DataDeserializer(dataDeserializerOptions));
        else console.log('No dataDeserializerOptions');
    }

    initDataTransformer(dataTransformerOptions){
        this.setTransformer(new DataTransformer(dataTransformerOptions));
    }

    initPipeline(){
        var pipeline = this.getPipeline();
        pipeline.reset();
        var loader = this.getLoader();
        if (loader) pipeline.add(loader.get.bind(loader));
        var parser = this.getParser();
        if (parser) pipeline.add(parser.parse.bind(parser));
        var deserializer = this.getDeserializer();
        if (deserializer) pipeline.add(deserializer.deserialize.bind(deserializer))
        var transformer = this.getTransformer();
        if (transformer) pipeline.add(transformer.transform.bind(transformer))
    }

    initDataSource(dataSourceOptions){
        if (dataSourceOptions){
            this.initName(dataSourceOptions.name);
            this.initDataLoader(dataSourceOptions.dataLoaderOptions); 
            this.initDataParser(dataSourceOptions.dataParserOptions);
            this.initDataDeserializer(dataSourceOptions.dataDeserializerOptions);
            this.initDataTransformer();
        }

        this.initPipeline();
    }

    // ==========
    // public
    // ----------
    get(){
        //return this.run();
        var promise = this.getPipeline().run();
        var print = (data)=>{ console.log('datasource',data); return data }
        // return promise.then(print);
        return promise;
    }

    /* added 23-05 */
    init(){
        this.initPipeline();
    }

    getDataLoader(){ return this.getLoader() }


}



export class DataSourceOptions{
    // ==========
    // public 
    // ----------
    setName(n){ this.name = n }
    getName(){ return this.name }

    getDataLoaderOptions(){ return this.dataLoaderOptions; }

    setDataLoaderOptions(dataLoaderOptions){
        this.dataLoaderOptions = (dataLoaderOptions instanceof DataLoaderOptions) ? dataLoaderOptions : new DataLoaderOptions(dataLoaderOptions);
    }

    getDataParserOptions(){ return this.dataParserOptions }
    setDataParserOptions(dataParserOptions){
        this.dataParserOptions = (dataParserOptions instanceof DataParserOptions) ? dataParserOptions : new DataParserOptions(dataParserOptions);
    }

    getDataDeserializerOptions(){ return this.dataDeserializerOptions }
    setDataDeserializerOptions(dataDeserializerOptions){
        this.dataDeserializerOptions = (dataDeserializerOptions instanceof DataDeserializerOptions) ? dataDeserializerOptions : new DataDeserializerOptions(dataDeserializerOptions); 
    }

    
    getDataTransformerOptions(){ return this.dataTransformerOptions }
    setDataTransformerOptions(dataTransformerOptions){ 
        this.dataTransformerOptions = (dataTransformerOptions instanceof DataTransformerOptions) ? dataTransformerOptions : new DataTransformerOptions(dataTransformerOptions);
     }
    
}


